
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/stakecut-university",
      function () {
        return require("private-next-pages/dashboard/stakecut-university.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/stakecut-university"])
      });
    }
  